import microsoftLogo from "../assets/microsoft-logo.svg"
import styles from "./MicrosoftSignInButton.module.scss"

type Props = {
  href: string
}

export function MicrosoftSignInButton({ href }: Props) {
  return (
    <a href={href} className={styles.button}>
      <img
        src={microsoftLogo}
        alt=""
        className={styles.logo}
        aria-hidden="true"
      />
      Sign in with Microsoft
    </a>
  )
}
